import React, {Component} from 'react';
import './index.less';

class Title extends Component {
  render() {
    const { className, iconfont, children } = this.props;
    return (
      <div className={`other-title ${className || ''}`}>
        <span className="other-title-left">
          <i className={`iconfont ${iconfont}`} />
          {children && children.title}
        </span>
        {children && children.content}
      </div>
    );
  }
}

export default Title;
